// Runway
// HB-8
import Carousel from '@common/components/Carousel';
import { getFilteredSliderImages } from '@common/models/Slider';
import { SliderSliceType } from '@common/store/slider/slice';
import { isBrowser, isMobile } from '@common/utils';
import SliderCta from '@components/SliderCta';
import { ReactComponent as LChevronRight } from '@images/LChevronRight.svg';
import AspectRatio from '@lib/AspectRatio';
import Image from '@lib/Image';
import classnames from 'classnames';
import React, { useState } from 'react';
export interface BannerCarousalProps {
  slider: SliderSliceType;
}

const BannerCarousal: React.FC<BannerCarousalProps> = ({ slider }) => {
  const MOBILE_ASPECT_RATIO = 414 / 428;
  const DESKTOP_ASPECT_RATIO = 1440 / 652;
  const filteredImages = getFilteredSliderImages({ slider, shouldImageBePresent: true });
  const [key, setKey] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [hover, setHover] = useState(false);
  if (isBrowser()) {
    window.onresize = () => {
      setKey(key + 1);
    };
  }
  if (key === 0)
    setTimeout(() => {
      setKey(key + 1);
    }, 1000);
  if (!filteredImages?.length) {
    return null;
  }
  return (
    <div
      className="container mx-auto px-0 relative slider-6 slider"
      key={key}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <AspectRatio aspectRatio={isMobile() ? MOBILE_ASPECT_RATIO : DESKTOP_ASPECT_RATIO}>
        <Carousel
          arrows={false}
          dots={false}
          lazyLoad={true}
          slidesPerPage={1}
          offset={1}
          autoPlay={hover ? null : 5000}
          addArrowClickHandler={true}
          setSlideIndex={setCurrentSlide}
          slideIndex={currentSlide}
        >
          {filteredImages?.map((banner, index) => {
            return (
              <AspectRatio key={banner.slider} aspectRatio={isMobile() ? MOBILE_ASPECT_RATIO : DESKTOP_ASPECT_RATIO}>
                <div className="w-full h-full relative">
                  <Image
                    src={banner.image}
                    className="object-center-top object-cover"
                    alt={`Hero Banner ${index + 1}`}
                    noDefaultFit
                  />
                  <div
                    className={classnames(
                      'flex flex-col items-center h-full w-full justify-center px-60 absolute top-0',
                      {
                        'bg-slider-overlay': banner.heading || banner.subheading,
                      },
                    )}
                  >
                    {banner.showCustomText ? (
                      <>
                        {banner.subheading ? (
                          <div
                            className="text-slider-text text-14 md:text-16 mb-10 md:mb-26 leading-16 tracking-140 uppercase md:leading-19 font-bold w-full text-center"
                            font-customisation="para-text"
                            color-customisation="banner-subHeading"
                          >
                            {banner.subheading}
                          </div>
                        ) : null}
                        <div
                          className="text-slider-text text-30 md:text-40 leading-47 leading-35 font-bold w-full text-center mb-10 md:mb-26"
                          font-customisation="section-heading"
                          color-customisation="banner-heading"
                        >
                          {banner.heading}
                        </div>
                      </>
                    ) : null}
                    {banner.link && banner.showButton ? <SliderCta link={banner.link} text={banner.label} /> : null}
                  </div>
                </div>
              </AspectRatio>
            );
          })}
        </Carousel>
        <div className="absolute bottom-0 left-0 right-0 flex justify-center items-center pb-40">
          <div
            className={classnames('text-white cursor-pointer', {
              'opacity-70 cursor-not-allowed': currentSlide <= 0,
            })}
            onClick={() => {
              if (currentSlide > 0) {
                setCurrentSlide(currentSlide - 1);
              }
            }}
          >
            <LChevronRight className="w-36 h-36" />
          </div>
          <div
            className={classnames('text-white cursor-pointer ml-32', {
              'opacity-70 cursor-not-allowed': currentSlide >= filteredImages.length - 1,
            })}
            onClick={() => {
              if (currentSlide < filteredImages.length - 1) {
                setCurrentSlide(currentSlide + 1);
              }
            }}
          >
            <LChevronRight className="transform -rotate-180 w-36 h-36" />
          </div>
        </div>
      </AspectRatio>
    </div>
  );
};

export default BannerCarousal;
